import React, {useCallback, useEffect, useState} from "react";
import {
    Document,
    Font,
    Image,
    Page,
    PDFViewer,
    StyleSheet,
    Text,
    View,
} from "@react-pdf/renderer";
import DialogComponent from "../../../../shared/components/dialog/dialogComponent";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ReplayIcon from "@mui/icons-material/Replay";
import BarCode from "../../../../assets/images/barcodepdf.png";
import commonService from "../../../../shared/services/common.service";
import {CommonService} from "../../../../shared/services";
import {ImageConfig} from "../../../../constants";

Font.register({
    family: "Lato",
    fonts: [
        {
            src: `/Lato-Regular.ttf`,
        },
        {
            src: `/Roboto-Bold.ttf`,
            fontWeight: "bold",
        },
        {
            src: `/Roboto-Italic.ttf`,
            fontWeight: "normal",
            fontStyle: "italic",
        },
        {
            src: `/Roboto-BoldItalic.ttf`,
            fontWeight: "bold",
            fontStyle: "italic",
        },
    ],
});
// Create styles
const styles = StyleSheet.create({
    page: {
        flexDirection: "column",
        position: "relative", // Ensure relative positioning for page content
        paddingBottom: "65px",
    },
    flex: {
        display: "flex",
        flexDirection: "row",
    },
    flexSpaceBetween: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    flexEqualSpace4: {
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 100 / 4,
    },
    body: {
        // paddingTop: 20,
        paddingLeft: 30,
        paddingBottom: 14,
        paddingRight: 30,
        width: "100%",
    },
    topHeaderContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    Container2: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        paddingTop: 10,
        paddingBottom: 10,
    },
    topHeaderDiv1: {
        flex: 1,
        height: "28px",
        // backgroundColor: "#E65D64",
        marginRight: 10,
        color: "#FFF",
        paddingTop: 5,
        paddingLeft: 10,
        fontSize: "14px",
        fontWeight: "bold",
    },
    logo: {
        width: 55,
        height: 28,
    },
    barCodeLogo: {
        width: 59,
        height: 15,
        marginLeft: 5,
    },
    section: {
        marginTop: 5,
        flexGrow: 1,
    },
    table: {
        width: "100%",
        flexDirection: "column",
        // borderStyle: "solid",
        // borderWidth: 0.5,
        // borderRightWidth: 0,
        // borderBottomWidth: 0,
        // borderColor: '#E2E2E2'
    },
    tableRow: {
        flexDirection: "row",
        borderStyle: "solid",
        // borderWidth: 0.5,
        // borderTopWidth: 0,
        // borderColor: '#E2E2E2'
    },
    tableCol10: {
        width: "20%",
        borderStyle: "solid",
        borderWidth: 0.5,
        // borderLeftWidth: 0,
        borderColor: "#E2E2E2",
    },
    tableCol90: {
        width: "80%",
        borderStyle: "solid",
        borderWidth: 0.5,
        // borderLeftWidth: 0,
        borderColor: "#E2E2E2",
    },
    cellHeader: {
        fontSize: 10,
        padding: 5,
        fontWeight: "bold",
    },
    cell: {
        fontSize: 8,
        padding: 5,
    },
});

const InsuranceTypes = [
    {
        title: "Primary Insurance",
        code: "primaryInsurance",
    },
    {
        title: "Secondary Insurance",
        code: "secondaryInsurance",
    },
    {
        title: "Tertiary Insurance",
        code: "tertiaryInsurance",
    },
];

const maxWidth = 30; // You can adjust this value as needed

const breakText = (text: string = "", maxWidth: number) => {
    const words = text?.split(" ");
    let line = "";
    let lines = [];

    words?.forEach((word) => {
        if ((line + word)?.length <= maxWidth) {
            line += (line ? " " : "") + word;
        } else {
            lines.push(line);
            line = word;
        }
    });

    if (line?.trim()) {
        lines.push(line);
    }
    return lines.join("\n");
};
// Create PDF component
const MyDocument = ({testOrderDetails, sampleIndex = 0}: any) => {
    const labThemeColor = testOrderDetails?.labDetails?.themeColor;
    const labThemeColorLight = CommonService.changeColorOpacity(
        labThemeColor,
        0.15
    );
    const labName = testOrderDetails?.labDetails?.name;
    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={styles.body}>
                    <View fixed style={{marginTop: 20, marginBottom: 20}}>
                        <View style={styles.topHeaderContainer}>
                            <View
                                style={{
                                    ...styles.topHeaderDiv1,
                                    backgroundColor: labThemeColor,
                                }}
                            >
                                <Text style={{fontWeight: "bold"}}>Requisition Form</Text>
                            </View>
                            <View>
                                <View style={styles.logo}>
                                    <Image
                                        src={
                                            testOrderDetails?.labDetails?.logo?.url ||
                                            ImageConfig.sdiLogo
                                        }
                                    />
                                </View>
                            </View>
                        </View>
                        <View style={styles.Container2}>
                            <View
                                style={{
                                    fontSize: "12px",
                                }}
                            >
                                <View style={styles.flex}>
                                    <Text style={{color: "#8B8E90"}}>Lab Director: </Text>
                                    <Text>
                                        {CommonService.capitalizeFirstLetterOfEachWord(
                                                testOrderDetails?.labDetails?.directorDetails?.firstName || ""
                                            ) || "N/A" +
                                            " " +
                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                testOrderDetails?.labDetails?.directorDetails?.lastName || ""
                                            )}
                                    </Text>
                                </View>
                            </View>
                            <View
                                style={{
                                    fontSize: "12px",
                                }}
                            >
                                <View style={styles.flex}>
                                    <Text style={{color: "#8B8E90"}}>Accession ID: </Text>
                                    <Text>
                                        {testOrderDetails?.samples?.[sampleIndex]?.labBarcode || "N/A"}
                                    </Text>
                                    <View style={styles.barCodeLogo}>
                                        <Image src={BarCode}/>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View
                            style={{
                                width: "100%",
                                height: "2px",
                                backgroundColor: "#DCDDDE",
                            }}
                        />
                    </View>
                    <View style={{flexDirection: "row"}}>
                        <View
                            style={{
                                width: "268px",
                                // height:"109px",
                                borderRadius: "6px",
                                border: "0.5px solid #8B8E90",
                                marginRight: "10px",
                            }}
                        >
                            <View
                                style={{
                                    height: "22px",
                                    borderBottom: "0.5px solid #8B8E90",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: labThemeColorLight,
                                    borderTopLeftRadius: "6px",
                                    borderTopRightRadius: "6px",
                                }}
                            >
                                <Text style={{fontSize: "8px"}}>PATIENT INFORMATION</Text>
                            </View>
                            <View
                                style={{
                                    paddingTop: "10px",
                                    paddingBottom: "10px",
                                    paddingLeft: "10px",
                                }}
                            >
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Name:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {
                                            CommonService.getValueOrFallback(
                                                CommonService.capitalizeFirstLetterOfEachWord(
                                                    testOrderDetails?.patientDetails?.firstName || ""
                                                ) +
                                                " " +
                                                CommonService.capitalizeFirstLetterOfEachWord(
                                                    testOrderDetails?.patientDetails?.lastName || ""
                                                )
                                            )
                                        }
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Patient ID:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {CommonService.getValueOrFallback(testOrderDetails?.patientDetails?.id)}
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Gender:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {
                                            CommonService.getValueOrFallback(
                                                CommonService.capitalizeFirstLetterOfEachWord(
                                                    testOrderDetails?.patientDetails?.gender
                                                ))
                                        }
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        DOB:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {commonService.formatDate(
                                            testOrderDetails?.patientDetails?.dateOfBirth
                                        )}
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                        Email ID:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {commonService.getValueOrFallback(testOrderDetails?.patientDetails?.emailId)}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View
                            style={{
                                width: "268px",
                                // height:"109px",
                                borderRadius: "6px",
                                border: "0.5px solid #8B8E90",
                                marginRight: "10px",
                            }}
                        >
                            <View
                                style={{
                                    height: "22px",
                                    borderBottom: "0.5px solid #8B8E90",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: labThemeColorLight,
                                    borderTopLeftRadius: "6px",
                                    borderTopRightRadius: "6px",
                                }}
                            >
                                <Text style={{fontSize: "8px"}}>ORDERING PHYSICIAN</Text>
                            </View>
                            <View
                                style={{
                                    paddingTop: "10px",
                                    paddingBottom: "10px",
                                    paddingLeft: "10px",
                                }}
                            >
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Name:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {
                                            CommonService.getValueOrFallback(CommonService.capitalizeFirstLetterOfEachWord(
                                                    testOrderDetails?.physicianDetails?.firstName || ""
                                                ) +
                                                " " +
                                                CommonService.capitalizeFirstLetterOfEachWord(
                                                    testOrderDetails?.physicianDetails?.lastName || ""
                                                ))
                                        }
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Facility Contact No:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {testOrderDetails?.facilityDetails?.adminDetails
                                            ?.mobileNumber
                                            ? CommonService.getMaskedMobileNumber(
                                                testOrderDetails?.facilityDetails?.adminDetails
                                                    ?.mobileNumber
                                            )
                                            : "N/A"}
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                        Facility Address:{" "}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: "7px",
                                            maxWidth: "100px",
                                        }}
                                    >
                                        {breakText(
                                            [
                                                testOrderDetails?.facilityDetails?.addressDetails
                                                    ?.addressLine1,
                                                testOrderDetails?.facilityDetails?.addressDetails
                                                    ?.addressLine2,
                                                testOrderDetails?.facilityDetails?.addressDetails?.city,
                                                testOrderDetails?.facilityDetails?.addressDetails
                                                    ?.state,
                                                testOrderDetails?.facilityDetails?.addressDetails
                                                    ?.zipcode,
                                            ]
                                                .filter(Boolean)
                                                .join(", "),
                                            maxWidth
                                        )}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View
                            style={{
                                width: "268px",
                                borderRadius: "6px",
                                border: "0.5px solid #8B8E90",
                            }}
                        >
                            <View
                                style={{
                                    height: "22px",
                                    borderBottom: "0.5px solid #8B8E90",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: labThemeColorLight,
                                    borderTopLeftRadius: "6px",
                                    borderTopRightRadius: "6px",
                                }}
                            >
                                <Text style={{fontSize: "8px"}}>SPECIMEN INFORMATION</Text>
                            </View>
                            <View
                                style={{
                                    paddingTop: "10px",
                                    paddingBottom: "10px",
                                    paddingLeft: "10px",
                                }}
                            >
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Order ID:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {CommonService.getValueOrFallback(testOrderDetails?.code)}
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Specimen Type:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {
                                            CommonService.getValueOrFallback(
                                                CommonService.capitalizeFirstLetterOfEachWord(
                                                    testOrderDetails?.samples?.[sampleIndex]?.sampleType || ""
                                                ))
                                        }
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Date Collected & Time:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {testOrderDetails?.samples?.[sampleIndex]?.dateOfCollection
                                            ? commonService.formatDate(
                                                testOrderDetails?.samples?.[sampleIndex]
                                                    ?.dateOfCollection
                                            )
                                            : "N/A"}
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Date Received & Time:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {testOrderDetails?.samples?.[sampleIndex]?.accessionedDate
                                            ? commonService.formatDate(
                                                testOrderDetails?.samples?.[sampleIndex]
                                                    ?.accessionedDate
                                            )
                                            : "N/A"}
                                    </Text>
                                </View>
                                <View style={styles.flex}>
                                    <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                        Date Reported & Time:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {testOrderDetails?.samples?.[sampleIndex]?.pdfGeneratedDate
                                            ? commonService.formatDate(
                                                testOrderDetails?.samples?.[sampleIndex]
                                                    ?.pdfGeneratedDate
                                            )
                                            : "N/A"}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    {testOrderDetails?.samples?.[sampleIndex]?.["primaryInsurance"]
                        ?.insuranceCompany && (
                        <View
                            style={{
                                width: "100%",
                                height: "auto",
                                borderRadius: "6px",
                                border: "0.5px solid #8B8E90",
                                marginTop: "10px",
                            }}
                        >
                            <View
                                style={{
                                    height: "22px",
                                    borderBottom: "0.5px solid #8B8E90",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: labThemeColorLight,
                                    borderTopLeftRadius: "6px",
                                    borderTopRightRadius: "6px",
                                }}
                            >
                                <Text style={{fontSize: "8px"}}>INSURANCE INFORMATION</Text>
                            </View>
                            {InsuranceTypes?.map((insurance, index) => {
                                const insuranceTitle = insurance.title;
                                const insuranceCode = insurance.code;
                                const isLastInsurance =
                                    !testOrderDetails?.samples?.[sampleIndex]?.[
                                        InsuranceTypes[index + 1]?.code
                                        ]?.insuranceCompany;
                                return testOrderDetails?.samples?.[sampleIndex]?.[insuranceCode]
                                    ?.insuranceCompany ? (
                                    <View
                                        style={{
                                            paddingTop: "10px",
                                            paddingBottom: "10px",
                                            paddingLeft: "15px",
                                            paddingRight: "10px",
                                            borderBottom: isLastInsurance
                                                ? "none"
                                                : "2px solid #DCDDDE",
                                        }}
                                    >
                                        <View style={styles.flex}>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text
                                                    style={{
                                                        color: "#8B8E90",
                                                        fontSize: "7px",
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    Insurance Type:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {insuranceTitle}
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}/>
                                            <View
                                                style={{...styles.flexEqualSpace4, flexBasis: 50}}
                                            >
                                                <Text
                                                    style={{
                                                        color: "#8B8E90",
                                                        fontSize: "7px",
                                                        marginBottom: "5px",
                                                    }}
                                                >
                                                    Insurance Company:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            testOrderDetails?.samples?.[sampleIndex]?.
                                                                [insuranceCode]?.insuranceCompany)
                                                    }
                                                </Text>
                                            </View>
                                            <View
                                                style={{...styles.flexEqualSpace4, flexBasis: 0}}
                                            />
                                        </View>
                                        <View
                                            style={{
                                                ...styles.flexSpaceBetween,
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <View style={styles.flexEqualSpace4}>
                                                <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                                    Insurer First Name:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                                breakText(
                                                                    testOrderDetails?.samples?.[sampleIndex]?.[
                                                                        insuranceCode
                                                                        ]?.firstName || "",
                                                                    17
                                                                )
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                                    Insurer Middle Name:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                                breakText(
                                                                    testOrderDetails?.samples?.[sampleIndex]?.[
                                                                        insuranceCode
                                                                        ]?.middleName || "",
                                                                    13
                                                                )
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                                    Insurer Last Name:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                                breakText(
                                                                    testOrderDetails?.samples?.[sampleIndex]?.[
                                                                        insuranceCode
                                                                        ]?.lastName || "",
                                                                    18
                                                                )
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                                    Insurer DOB:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {commonService.formatDate(
                                                        testOrderDetails?.samples?.[sampleIndex]?.[
                                                            insuranceCode
                                                            ]?.dateOfBirth
                                                    ) || ""}
                                                </Text>
                                            </View>
                                        </View>
                                        <View
                                            style={{
                                                ...styles.flexSpaceBetween,
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <View style={styles.flexEqualSpace4}>
                                                <Text
                                                    style={{
                                                        color: "#8B8E90",
                                                        fontSize: "7px",
                                                    }}
                                                >
                                                    Relationship:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                                breakText(
                                                                    testOrderDetails?.samples?.[sampleIndex]?.[
                                                                        insuranceCode
                                                                        ]?.relationship || "",
                                                                    28
                                                                )
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                                    Policy Number:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            breakText(
                                                                testOrderDetails?.samples?.[sampleIndex]?.[
                                                                    insuranceCode
                                                                    ]?.policyNumber || "",
                                                                18
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                                    Payor ID:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            breakText(
                                                                testOrderDetails?.samples?.[sampleIndex]?.[
                                                                    insuranceCode
                                                                    ]?.payerId || "",
                                                                18
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                                    EnB Status:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {/*{testOrderDetails?.samples?.[sampleIndex]?.[insuranceCode]*/}
                                                    {/*    ?.enbotDetails?.status === true*/}
                                                    {/*    ? "Verified"*/}
                                                    {/*    : testOrderDetails?.samples?.[sampleIndex]?.[insuranceCode]*/}
                                                    {/*        ?.enbotDetails?.status === false ? "Unverified" : '-'}*/}
                                                    {"-"}
                                                </Text>
                                            </View>
                                        </View>
                                        {/*new one*/}
                                        <View
                                            style={{
                                                ...styles.flexSpaceBetween,
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <View style={styles.flexEqualSpace4}>
                                                <Text
                                                    style={{
                                                        color: "#8B8E90",
                                                        fontSize: "7px",
                                                    }}
                                                >
                                                    Network/Plan Name:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                                breakText(
                                                                    testOrderDetails?.samples?.[sampleIndex]?.[
                                                                        insuranceCode
                                                                        ]?.networkPlanName,
                                                                    18
                                                                )
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                                    Group Name:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                                breakText(
                                                                    testOrderDetails?.samples?.[sampleIndex]?.[
                                                                        insuranceCode
                                                                        ]?.groupName || "",
                                                                    18
                                                                )
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text
                                                    style={{
                                                        color: "#8B8E90",
                                                        fontSize: "7px",
                                                    }}
                                                >
                                                    Group/Network:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                                breakText(
                                                                    testOrderDetails?.samples?.[sampleIndex]?.[
                                                                        insuranceCode
                                                                        ]?.groupNetwork || "",
                                                                    18
                                                                )
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text style={{color: "#8B8E90", fontSize: "7px"}}>
                                                    Effective Date:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {commonService.formatDate(
                                                        testOrderDetails?.samples?.[sampleIndex]?.[
                                                            insuranceCode
                                                            ]?.effectiveDate
                                                    )}
                                                </Text>
                                            </View>
                                        </View>
                                        <View style={{...styles.flexSpaceBetween}}>
                                            <View style={styles.flexEqualSpace4}>
                                                <Text
                                                    style={{
                                                        color: "#8B8E90",
                                                        fontSize: "7px",
                                                    }}
                                                >
                                                    IPA/Medical Group Name:{" "}
                                                </Text>
                                                <Text style={{fontSize: "7px"}}>
                                                    {
                                                        CommonService.getValueOrFallback(
                                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                                testOrderDetails?.samples?.[sampleIndex]?.[
                                                                    insuranceCode
                                                                    ]?.ipaMedicalGroupName || ""
                                                            ))
                                                    }
                                                </Text>
                                            </View>
                                        </View>
                                        {/*end of new one*/}
                                    </View>
                                ) : (
                                    <></>
                                );
                            })}
                        </View>
                    )}
                    <View
                        style={{
                            width: "100%",
                            height: "2px",
                            backgroundColor: "#DCDDDE",
                            marginTop: "10px",
                            marginBottom: "10px",
                        }}
                    />

                    <View
                        style={{
                            width: "100%",
                            backgroundColor: "#EFEFEF",
                            padding: "4px",
                        }}
                    >
                        <Text
                            style={{
                                color: "#1D1C1D",
                                fontSize: "10px",
                                marginLeft: "10px",
                                marginRight: "10px",
                            }}
                        >
                            TEST NAME
                        </Text>
                    </View>
                    <View
                        style={{
                            width: "100%",
                            border: "0.5px solid #E2E2E2",
                            padding: "6px",
                            marginTop: "5px",
                        }}
                    >
                        <Text
                            style={{
                                color: "#1D1C1D",
                                fontSize: "8px",
                                marginLeft: "10px",
                                marginRight: "10px",
                            }}
                        >
                            {CommonService.getValueOrFallback(testOrderDetails?.samples?.[sampleIndex]?.testDetails?.name)}
                        </Text>
                    </View>

                    {testOrderDetails?.samples?.[sampleIndex]?.testDetails?.testLayoutDetails?.[0]?.biomarkerObj
                        ?.map((testBiomarkers: any) => {
                                const names = testBiomarkers?.biomarkerDetails
                                    ?.map((biomarker: { name: any }) =>
                                        CommonService.capitalizeFirstLetterOfEachWord(
                                            biomarker.name || ""
                                        )
                                    )
                                    .join(", ");
                                return (
                                    <>
                                        <View
                                            style={{
                                                width: "100%",
                                                backgroundColor: "#EFEFEF",
                                                padding: "4px",
                                                marginTop: "10px",
                                            }}
                                        >
                                            <Text
                                                style={{
                                                    color: "#1D1C1D",
                                                    fontSize: "10px",
                                                    marginLeft: "10px",
                                                    marginRight: "10px",
                                                }}
                                            >
                                                {CommonService.capitalizeFirstLetterOfEachWord(
                                                    testBiomarkers?.title
                                                ) || "Biomarkers"}
                                            </Text>
                                        </View>
                                        <View
                                            style={{
                                                width: "100%",
                                                border: "0.5px solid #E2E2E2",
                                                padding: "6px",
                                                marginTop: "5px",
                                            }}
                                        >
                                            <Text
                                                style={{
                                                    color: "#1D1C1D",
                                                    fontSize: "8px",
                                                    marginLeft: "10px",
                                                    marginRight: "10px",
                                                }}
                                            >
                                                {names}
                                            </Text>
                                        </View>
                                    </>
                                );
                            }
                        )}

                    {testOrderDetails?.samples?.[sampleIndex]?.icdCodeDetails?.length >
                        0 && (
                            <View break={false}>
                                <View
                                    style={{
                                        width: "100%",
                                        backgroundColor: "#EFEFEF",
                                        padding: "4px",
                                        marginTop: "10px",
                                    }}
                                    fixed
                                >
                                    <Text
                                        style={{
                                            color: "#1D1C1D",
                                            fontSize: "10px",
                                            marginLeft: "10px",
                                            marginRight: "10px",
                                        }}
                                    >
                                        ICD CODES
                                    </Text>
                                </View>

                                <View style={styles.section}>
                                    <View style={styles.table}>
                                        <View style={styles.tableRow} fixed>
                                            <View style={styles.tableCol10}>
                                                <Text style={styles.cellHeader}>ICD Code</Text>
                                            </View>
                                            <View style={styles.tableCol90}>
                                                <Text style={styles.cellHeader}>Description</Text>
                                            </View>
                                        </View>
                                        {testOrderDetails?.samples?.[
                                            sampleIndex
                                            ]?.icdCodeDetails?.map((icdCodeObject: any) => {
                                            return (
                                                <View style={styles.tableRow}>
                                                    <View style={styles.tableCol10}>
                                                        <Text style={styles.cell}>
                                                            {icdCodeObject?.icdCode}
                                                        </Text>
                                                    </View>
                                                    <View style={styles.tableCol90}>
                                                        <Text style={styles.cell}>
                                                            {CommonService.getValueOrFallback(icdCodeObject?.description)}
                                                        </Text>
                                                    </View>
                                                </View>
                                            );
                                        })}
                                    </View>
                                </View>
                            </View>
                        )}
                    {testOrderDetails?.samples?.[sampleIndex]?.medicationDetails?.length >
                        0 && (
                            <View break={false}>
                                <View
                                    style={{
                                        width: "100%",
                                        backgroundColor: "#EFEFEF",
                                        padding: "4px",
                                        marginTop: "10px",
                                    }}
                                    fixed
                                >
                                    <Text
                                        style={{
                                            color: "#1D1C1D",
                                            fontSize: "10px",
                                            marginLeft: "10px",
                                            marginRight: "10px",
                                        }}
                                    >
                                        Medication List
                                    </Text>
                                </View>
                                <View style={styles.section}>
                                    <View style={styles.table}>
                                        <View style={styles.tableRow} fixed>
                                            <View style={styles.tableCol10}>
                                                <Text style={styles.cellHeader}>Brand Name</Text>
                                            </View>
                                            <View style={styles.tableCol10}>
                                                <Text style={styles.cellHeader}>Generic Name</Text>
                                            </View>
                                            <View style={styles.tableCol10}>
                                                <Text style={styles.cellHeader}>Dosage Form</Text>
                                            </View>
                                            <View style={styles.tableCol10}>
                                                <Text style={styles.cellHeader}>Dosage</Text>
                                            </View>
                                            <View style={styles.tableCol10}>
                                                <Text style={styles.cellHeader}>Unit</Text>
                                            </View>
                                        </View>
                                        {testOrderDetails?.samples?.[
                                            sampleIndex
                                            ]?.medicationDetails?.map(
                                            (medicationObj: any, index: number) => {
                                                const {
                                                    brandName = "",
                                                    genericName = "",
                                                    dosageForm = "",
                                                    dosage = "",
                                                    unit = "",
                                                } = CommonService.formatMedicationNames(medicationObj); // Capitalize names

                                                return (
                                                    <View
                                                        style={styles.tableRow}
                                                        key={medicationObj.id || index}
                                                    >
                                                        <View style={styles.tableCol10}>
                                                            <Text
                                                                style={styles.cell}>{CommonService.getValueOrFallback(brandName)}</Text>
                                                        </View>
                                                        <View style={styles.tableCol10}>
                                                            <Text
                                                                style={styles.cell}>{CommonService.getValueOrFallback(genericName)}</Text>
                                                        </View>
                                                        <View style={styles.tableCol10}>
                                                            <Text
                                                                style={styles.cell}>{CommonService.getValueOrFallback(dosageForm)}</Text>
                                                        </View>
                                                        <View style={styles.tableCol10}>
                                                            <Text
                                                                style={styles.cell}>{CommonService.getValueOrFallback(dosage)}</Text>
                                                        </View>
                                                        <View style={styles.tableCol10}>
                                                            <Text
                                                                style={styles.cell}>{CommonService.getValueOrFallback(unit)}</Text>
                                                        </View>
                                                    </View>
                                                );
                                            }
                                        )}
                                    </View>
                                </View>
                            </View>
                        )}
                    {testOrderDetails?.samples?.[sampleIndex]?.cptCodeDetails?.length >
                        0 && (
                            <View break={false}>
                                <View
                                    style={{
                                        width: "100%",
                                        backgroundColor: "#EFEFEF",
                                        padding: "4px",
                                        marginTop: "10px",
                                    }}
                                >
                                    <Text
                                        style={{
                                            color: "#1D1C1D",
                                            fontSize: "10px",
                                            marginLeft: "10px",
                                            marginRight: "10px",
                                        }}
                                    >
                                        CPT CODES
                                    </Text>
                                </View>

                                <View style={styles.section}>
                                    <View style={styles.table}>
                                        <View style={styles.tableRow} fixed>
                                            <View style={styles.tableCol10}>
                                                <Text style={styles.cellHeader}>CPT Code</Text>
                                            </View>
                                            <View style={styles.tableCol90}>
                                                <Text style={styles.cellHeader}>Description</Text>
                                            </View>
                                        </View>
                                        {testOrderDetails?.samples?.[
                                            sampleIndex
                                            ]?.cptCodeDetails?.map((cptCodeObject: any) => {
                                            return (
                                                <View style={styles.tableRow}>
                                                    <View style={styles.tableCol10}>
                                                        <Text style={styles.cell}>
                                                            {CommonService.getValueOrFallback(cptCodeObject?.cptCode)}
                                                        </Text>
                                                    </View>
                                                    <View style={styles.tableCol90}>
                                                        <Text style={styles.cell}>
                                                            {CommonService.getValueOrFallback(cptCodeObject?.description)}
                                                        </Text>
                                                    </View>
                                                </View>
                                            );
                                        })}
                                    </View>
                                </View>
                            </View>
                        )}

                    {/*Patient Consent form*/}
                    <View wrap={false}>
                        <View
                            style={{
                                width: "100%",
                                backgroundColor: "#EFEFEF",
                                padding: "4px",
                                marginTop: "10px",
                            }}
                        >
                            <Text
                                style={{
                                    color: "#1D1C1D",
                                    fontSize: "10px",
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                }}
                            >
                                PATIENT CONSENT FOR TESTING
                            </Text>
                        </View>
                        <View
                            style={{
                                width: "100%",
                                border: "0.5px solid #E2E2E2",
                                padding: "6px",
                                marginTop: "5px",
                            }}
                        >
                            <Text
                                style={{
                                    color: "#1D1C1D",
                                    fontSize: "8px",
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                }}
                            >
                                I acknowledge that this specimen was voluntarily provided for
                                analysis by my physician and/or {labName}. I authorize {labName}{" "}
                                to release the test results to the ordering healthcare provider.
                                Furthermore, I consent to the lab and my healthcare provider
                                releasing any necessary medical information to my insurance
                                provider to process the claim. I authorize
                                {labName} to administer results on my behalf and to bill my
                                health insurance provider for the services rendered.
                                Additionally, I authorize my ordering healthcare provider and my
                                insurance company to release any information needed to determine
                                benefits for laboratory services to {labName} and its agents. I
                                understand and acknowledge that payments for these services may
                                be made by my health insurance provider directly to {labName}.
                            </Text>
                        </View>
                        <View style={{marginLeft: "auto", marginTop: "8px"}}>
                            <View style={styles.flex}>
                                <Text
                                    style={{
                                        color: "#8B8E90",
                                        fontSize: "7px",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Electronic order confirmed and verbally consented by:{" "}
                                </Text>
                                <Text style={{fontSize: "7px"}}>
                                    {
                                        CommonService.getValueOrFallback(
                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                testOrderDetails?.patientDetails?.firstName
                                            ) +
                                            " " +
                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                testOrderDetails?.patientDetails?.lastName
                                            ))
                                    }
                                </Text>
                            </View>
                            <View style={{marginLeft: "auto"}}>
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Date:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {testOrderDetails?.samples?.[sampleIndex]?.dateOfCollection
                                            ? commonService.formatDate(
                                                testOrderDetails?.samples?.[sampleIndex]
                                                    ?.dateOfCollection
                                            )
                                            : "N/A"}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    {/*Physician authorization*/}
                    <View wrap={false}>
                        <View
                            style={{
                                width: "100%",
                                backgroundColor: "#EFEFEF",
                                padding: "4px",
                                marginTop: "10px",
                            }}
                        >
                            <Text
                                style={{
                                    color: "#1D1C1D",
                                    fontSize: "10px",
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                }}
                            >
                                PHYSICIAN AUTHORIZATION
                            </Text>
                        </View>
                        <View
                            style={{
                                width: "100%",
                                border: "0.5px solid #E2E2E2",
                                padding: "6px",
                                marginTop: "5px",
                            }}
                        >
                            <Text
                                style={{
                                    color: "#1D1C1D",
                                    fontSize: "8px",
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                }}
                            >
                                I understand that each test I order constitutes a billable
                                event, and the patient’s medical records must accurately reflect
                                my order. I authorize {labName} to release the test results and
                                relevant medical information to the patient’s insurance carrier
                                as part of the coverage and reimbursement process.
                            </Text>
                        </View>

                        <View style={{marginLeft: "auto", marginTop: "8px"}}>
                            <View style={styles.flex}>
                                <Text
                                    style={{
                                        color: "#8B8E90",
                                        fontSize: "7px",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Order electronically entered and digitally signed by:{" "}
                                </Text>
                                <Text style={{fontSize: "7px"}}>
                                    {
                                        CommonService.getValueOrFallback(
                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                testOrderDetails?.physicianDetails?.firstName
                                            ) +
                                            " " +
                                            CommonService.capitalizeFirstLetterOfEachWord(
                                                testOrderDetails?.physicianDetails?.lastName
                                            ))
                                    }
                                </Text>
                            </View>
                            <View style={{marginLeft: "auto"}}>
                                <View style={styles.flex}>
                                    <Text
                                        style={{
                                            color: "#8B8E90",
                                            fontSize: "7px",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        Date:{" "}
                                    </Text>
                                    <Text style={{fontSize: "7px"}}>
                                        {testOrderDetails?.samples?.[sampleIndex]?.dateOfCollection
                                            ? commonService.formatDate(
                                                testOrderDetails?.samples?.[sampleIndex]
                                                    ?.dateOfCollection
                                            )
                                            : "N/A"}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View
                        style={{
                            width: "100%",
                            marginTop: "30px",
                            fontSize: "9.3px",
                            color: "#202020",
                        }}
                    >
                        <Text>
                            ---------------------------------------------------------------------------
                            END OF FORM
                            ---------------------------------------------------------------------------
                        </Text>
                    </View>
                </View>
                <View
                    fixed
                    style={{
                        marginTop: "auto",
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                    }}
                >
                    <View
                        style={{
                            width: "100%",
                            backgroundColor: labThemeColor,
                            color: "#FFF",
                            fontSize: "8px",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "20px",
                        }}
                    >
                        <Text>
                            {CommonService.capitalizeFirstLetterOfEachWord(labName || "N/A")},
                            {CommonService.capitalizeFirstLetterOfEachWord(
                                testOrderDetails?.labDetails?.addressLine1 || "N/A"
                            )}
                            ,
                            {CommonService.capitalizeFirstLetterOfEachWord(
                                testOrderDetails?.labDetails?.city || "N/A"
                            )}
                            ,
                            {CommonService.capitalizeFirstLetterOfEachWord(
                                testOrderDetails?.labDetails?.state || "N/A"
                            )}
                            {testOrderDetails?.labDetails?.zipcode || "N/A"} | Tel:{" "}
                            {testOrderDetails?.labDetails?.mobileNumber
                                ? CommonService.getMaskedMobileNumber(
                                    testOrderDetails?.labDetails?.mobileNumber
                                )
                                : "N/A"}
                            {testOrderDetails?.labDetails?.directorDetails?.faxNumber &&
                                ` | FAX: ${testOrderDetails?.labDetails?.directorDetails?.faxNumber}`}
                            {testOrderDetails?.labDetails?.cliaId &&
                                ` | CLIA: ${testOrderDetails?.labDetails?.cliaId}`}
                        </Text>
                    </View>
                    <View style={styles.flex}>
                        <View
                            style={{
                                flexBasis: "310px",
                                marginLeft: "20px",
                                marginTop: "10px",
                                marginBottom: "10px",
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: "7px",
                                    color: "#202020",
                                }}
                            >
                                This document contains private and confidential health
                                information protected by state and federal law. If you have
                                received this document in error, please call{" "}
                                {
                                    CommonService.getValueOrFallback(
                                        CommonService.getMaskedMobileNumber(
                                            testOrderDetails?.labDetails?.mobileNumber
                                        ))
                                }
                                .
                            </Text>
                        </View>
                        <View
                            style={{
                                flex: "1",
                                marginRight: "20px",
                                marginTop: "10px",
                                marginBottom: "10px",
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: "7px",
                                    marginLeft: "auto",
                                    color: "#202020",
                                }}
                            >
                                All rights reserved
                            </Text>
                            <Text
                                style={{
                                    fontSize: "7px",
                                    marginLeft: "auto",
                                }}
                            >
                                Doc. Ver. 1.0
                            </Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

interface PDFFileForRequisitionProps {
    testOrderDetails?: any;
    sampleIndex?: number;
}

// Component
const PDFFileForRequisition = (props: PDFFileForRequisitionProps) => {
    const {testOrderDetails, sampleIndex} = props;
    const [isBiomarkerListLoading, setIsBiomarkerListLoading] = useState(false);
    const [isBiomarkerListFailed, setIsBiomarkerListFailed] = useState(false);
    /*
      Setting the biomarker details list in sample test details -> test layout details.
      before the biomarker details list was coming biomarkerObj, currently only coming the biomarker list ids.
      So, getting the biomarker list from another api and updating the same testOrderDetails.
       */
    const updateBiomarkerDetails = useCallback(() => {
        setIsBiomarkerListLoading(true);
        const sampleBiomarkerIds =
            testOrderDetails?.samples?.[sampleIndex || 0]?.testDetails
                ?.biomarkerIds || [];
        const payload = {
            biomarkerIds: sampleBiomarkerIds,
        };
        CommonService._test
            .getBiomarkerListByIds(payload)
            .then((response) => {
                const biomarkerDetails = response?.data?.filter((biomarker: any) =>
                    sampleBiomarkerIds.includes(biomarker?.id)
                );
                const biomarkerList =
                    testOrderDetails?.samples?.[sampleIndex || 0]?.testDetails
                        ?.testLayoutDetails?.[0]?.biomarkerObj || [];
                if (biomarkerList?.length > 0) {
                    biomarkerList?.forEach((testBiomarkers: any) => {
                        testBiomarkers.biomarkerDetails = biomarkerDetails?.filter(
                            (biomarker: any) => {
                                return testBiomarkers.biomarkerIds?.includes(biomarker.id);
                            }
                        );
                    });
                }
                setIsBiomarkerListFailed(false);
                setIsBiomarkerListLoading(false);
            })
            .catch((error) => {
                setIsBiomarkerListFailed(true);
                setIsBiomarkerListLoading(false);
                console.error("Something went wrong", error);
            });
    }, [sampleIndex, testOrderDetails]);

    useEffect(() => {
        updateBiomarkerDetails();
    }, [sampleIndex, testOrderDetails, updateBiomarkerDetails]);
    const [showPDF, setShowPDF] = useState(false);

    const showRequisitionForm = true;
    console.log({testOrderDetails}, "this is the test order details");
    if (!showRequisitionForm) {
        return <></>;
    }
    return (
        <div>
            {/*<PDFDownloadLink document={<MyDocument/>} fileName="example.pdf">*/}
            {/*    {({blob, url, loading, error}) =>*/}
            {/*        loading ? "Loading document..." : "Download PDF"*/}
            {/*    }*/}
            {/*</PDFDownloadLink>*/}
            <ButtonComponent
                variant="contained"
                color={isBiomarkerListFailed ? "error" : "secondary"}
                isLoading={isBiomarkerListLoading}
                handleClick={() => {
                    isBiomarkerListFailed
                        ? updateBiomarkerDetails()
                        : setShowPDF(!showPDF);
                    // console.log(testOrderDetails);
                }}
                startIcon={
                    isBiomarkerListFailed ? (
                        <ReplayIcon/>
                    ) : showPDF ? (
                        <VisibilityOffIcon/>
                    ) : (
                        <Visibility/>
                    )
                }
            >
                {isBiomarkerListFailed ? "Reload Biomarker" : "Requisition Form"}
            </ButtonComponent>

            {showPDF && (
                <div>
                    <DialogComponent
                        maxWidth={"md"}
                        open={showPDF}
                        onClose={() => {
                            setShowPDF(false);
                        }}
                    >
                        <div style={{marginLeft: "auto"}}>
                            <ButtonComponent
                                handleClick={() => {
                                    setShowPDF(false);
                                }}
                            >
                                Close
                            </ButtonComponent>
                        </div>
                        <PDFViewer width="850" height="500">
                            <MyDocument
                                testOrderDetails={testOrderDetails}
                                sampleIndex={sampleIndex}
                            />
                        </PDFViewer>
                    </DialogComponent>
                </div>
            )}
        </div>
    );
};

export default PDFFileForRequisition
